import type { Stratagem } from "@hd2/data";
import { useEffect, useState } from "react";
import { isExcludedItemName } from "../lib/excluded-items.ts";

let cache: Stratagem[] | null = null;
let pending: Promise<Stratagem[]> | null = null;

async function fetchStratagems(): Promise<Stratagem[]> {
	if (cache) {
		return cache;
	}
	if (!pending) {
		pending = fetch("/api/stratagems")
			.then((r) => r.json() as Promise<{ stratagems: Stratagem[] }>)
			.then((data) => {
				cache = data.stratagems.filter((s) => !isExcludedItemName(s.name));
				return cache;
			});
	}
	return pending;
}

export function useStratagems(): {
	stratagems: Stratagem[];
	loading: boolean;
} {
	const [stratagems, setStratagems] = useState<Stratagem[]>(() => cache ?? []);
	const [loading, setLoading] = useState(cache === null);

	useEffect(() => {
		if (cache) {
			setStratagems(cache);
			setLoading(false);
			return;
		}
		let alive = true;
		fetchStratagems()
			.then((list) => {
				if (alive) {
					setStratagems(list);
					setLoading(false);
				}
			})
			.catch(() => {
				if (alive) {
					setLoading(false);
				}
			});
		return () => {
			alive = false;
		};
	}, []);

	return { stratagems, loading };
}
